import { Link } from 'react-router-dom';

import { PAGES } from '../../constants/pages';
import { useGetCreditsQuery } from 'data/__generated__';

import { Header, HeaderTitle } from 'components/Header';
import { TotemPrimaryButton } from 'components/TotemPrimaryButton';
import { DataTable } from 'components/DataTable';
import { PageTitle } from 'components/PageTitle';

import { creditsColumns, type CreditRow, type CreditsFilterInput } from './constants/creditsColumns';

export const CreditsList = () => {
    const defaultFilters: CreditsFilterInput = {};

    const {
        loading: creditsLoading,
        data: creditsData,
        error: creditsError,
        refetch,
        fetchMore: fetchMoreCredits,
    } = useGetCreditsQuery({
        variables: { offset: 0 },
        fetchPolicy: 'cache-and-network',
        notifyOnNetworkStatusChange: true,
    });

    if (creditsError) {
        throw new Error('Une erreur est survenue lors du chargement des crédits');
    }

    const credits = creditsData?.credits.credits ?? [];
    const hasMore = creditsData?.credits.hasMore ?? false;

    return (
        <div className="flex h-full flex-1 flex-col overflow-hidden bg-inherit">
            <Header>
                <HeaderTitle>
                    <PageTitle page={PAGES.credits} />
                </HeaderTitle>
                <Link to="/credit/create">
                    <TotemPrimaryButton>Créer un crédit</TotemPrimaryButton>
                </Link>
            </Header>
            <div className="flex flex-1 flex-col overflow-hidden p-4">
                <DataTable<CreditRow, CreditsFilterInput>
                    columns={creditsColumns}
                    data={credits}
                    filterMode="server"
                    getRowId={(row) => row._id || ''}
                    getRowLink={(row) => `/credit/${row._id}`}
                    hasMore={hasMore}
                    isLoading={creditsLoading}
                    refetch={async (vars) => {
                        await refetch({
                            offset: 0,
                            userId: vars.filters?.userId,
                            types: vars.filters?.types,
                        });
                    }}
                    fetchMore={async (opts) => {
                        await fetchMoreCredits({
                            variables: {
                                offset: opts.variables.offset ?? credits.length,
                                userId: opts.variables.filters?.userId,
                                types: opts.variables.filters?.types,
                            },
                        });
                    }}
                    defaultFilters={defaultFilters}
                />
            </div>
        </div>
    );
};
